<div class="color-picker-dialog-container"
    [style.top.px]="top"
    [style.left.px]="left">
    <app-color-picker
        [color]="color || '#0085ff'"
        [openByDefault]="true"
        (colorChanged)="onColorChanged($event)"></app-color-picker>
</div>
